import { render } from "./ImagePicker.vue?vue&type=template&id=57416878"
import script from "./ImagePicker.vue?vue&type=script&lang=ts"
export * from "./ImagePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script